import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSidebar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.334 40a3.2 3.2 0 0 1-2.355-.98A3.2 3.2 0 0 1 4 36.667V11.333q0-1.374.98-2.354a3.2 3.2 0 0 1 2.354-.98h33.333q1.374 0 2.354.98t.98 2.354v25.333q0 1.375-.98 2.355a3.2 3.2 0 0 1-2.354.979zM20 36.666h20.667V11.333H20zm-3.333 0V11.333H7.334v25.333z" })
});
export default SvgSidebar;
